import React from 'react';

import ElementConstants from '../../../../shared/constants/elements';

import FormActions from '../../../../shared/actions/form';

import InputLabel from '../../widgets/input-label';
import InputHint from '../../widgets/input-hint';
import InputPlaceholder from '../../widgets/input-placeholder';
import BulkEditOptionsModal from '../../../../shared/components/modals/bulk-edit-options-modal';

import { DragSource, DropTarget } from '../../../../../../../common/react-dnd-2.6.0/dist/ReactDnD.min';

import SVGIcon from '../../../../../../../common/react/components/svg-icon';
import Localization from '../../../../../../../common/edlio-js/models/BackendLocalization';
import {cmsColors} from "../../../../../../../common/edlio-js/constants";
import DraggableItems from "../../../constants/dnd";
import ReactDOM from "react-dom";


const inputSource = {
	// React-DnD method returns dragged item props upon initiating drag operation
	beginDrag(props) {
		return props;
	}
}

const dropTarget = {

	/**
	 * React-DnD @method drop
	 * dispatches input move event when user drops an input in an input group target.
	 * The order is determined by the position of the dragged element relative to
	 * the existing elements.
	 * @params are all from React-DnD
	 */
	drop(props, monitor, component) {
		const draggedItem = monitor.getItem();
		const targetItem = props;

		// Determine rectangle on screen
		const targetBoundingRect = ReactDOM.findDOMNode(component).getBoundingClientRect();
		// Get vertical middle of target
		const targetMiddleY = ( targetBoundingRect.bottom - targetBoundingRect.top ) / 2;
		// Determine mouse position
		const clientOffset = monitor.getClientOffset();
		// Get number of pixels to the top of target
		const targetClientY = clientOffset.y - targetBoundingRect.top;

		if (
			( draggedItem.rowIndex !== targetItem.rowIndex )
		) {
			return;
		}

		if ( monitor.canDrop() ) {
			FormActions.moveInputFromGroup(draggedItem.fieldsetIndex, draggedItem.rowIndex, draggedItem.index, draggedItem.optionNumber, targetItem.optionNumber, 'options');
			// Reset drop-zone state after drop operation
			component.setState({
				sameRow: draggedItem.rowIndex === targetItem.rowIndex,
				topQuadrantHovered: false,
				bottomQuadrantHovered: false
			});
			return;
		}
	},

	/**
	 * React-DnD @method hover
	 * display an active drop-zone upon hovering an input in a group.
	 * The order is determined by the position of the dragged element relative to
	 * the existing elements.
	 * @params are all from React-DnD
	 */
	hover(props, monitor, component) {
		const draggedItem = monitor.getItem();
		const targetItem = props;

		// Determine rectangle on screen
		const targetBoundingRect = ReactDOM.findDOMNode(component).getBoundingClientRect();
		// Get vertical middle of target
		const targetMiddleY = ( targetBoundingRect.bottom - targetBoundingRect.top ) / 2;
		// Determine mouse position
		const clientOffset = monitor.getClientOffset();
		// Get number of pixels to the top of target
		const targetClientY = clientOffset.y - targetBoundingRect.top;

		// Mouse is positioned in top quadrant of drop target moving down
		if ( targetClientY < targetMiddleY ) {
			component.setState({
				sameRow: draggedItem.rowIndex === targetItem.rowIndex,
				topQuadrantHovered: true,
				bottomQuadrantHovered: false
			});
		}


		// Mouse is positioned in bottom quadrant of drop target moving up
		if ( targetClientY > targetMiddleY ) {
			component.setState({
				sameRow: draggedItem.rowIndex === targetItem.rowIndex,
				topQuadrantHovered: false,
				bottomQuadrantHovered: true
			});
		}
	}

}

@DragSource(DraggableItems.INPUT_FROM_GROUP, inputSource, (connect, monitor) => ({
	connectDragSource: connect.dragSource(),
	connectDragPreview: connect.dragPreview(),
	isDragging: monitor.isDragging()
}))
@DropTarget([DraggableItems.INPUT_FROM_GROUP, DraggableItems.INPUT_FROM_GROUP], dropTarget, (connect, monitor) => ({
	connectDropTarget: connect.dropTarget(),
	isOver: monitor.isOver(),
	canDrop: monitor.canDrop()
}))
export class Option extends React.Component {
	constructor(props) {
		super(props);
	}

	handleBlur = () => {
		const {
			fieldsetIndex,
			rowIndex,
			index,
			label,
			optionNumber
		} = this.props;

		const oldLabel = label;
		const newLabel = this.refs.label.refs.input.value;

		if ( newLabel !== '' && newLabel !== oldLabel ) {
			FormActions.updateSelectMenuOptionLabel(fieldsetIndex, rowIndex, index, optionNumber, newLabel);
		}
	}

	remove = () => {
		const {
			fieldsetIndex,
			rowIndex,
			index,
			optionNumber
		} = this.props;

		setTimeout(() => {
			FormActions.removeOptionFromSelectMenu(fieldsetIndex, rowIndex, index, optionNumber);
		}, 0);
	}

	render() {
		let localization = new Localization(window.edlio.localizations);
		const {
			numOptions,
			isItem,
			isOver,
			connectDropTarget,
			connectDragSource,
			connectDragPreview,
			isDragging
		} = this.props;

		const optionClasses = ( isDragging ) ? 'dragging option' : 'option';
		const topDropZoneClasses = ( isOver && this.state.sameRow && this.state.topQuadrantHovered ) ? 'drop-zone-indicator' : 'hidden drop-zone-indicator';
		const bottomDropZoneClasses = ( isOver && this.state.sameRow && this.state.bottomQuadrantHovered ) ? 'drop-zone-indicator' : 'hidden drop-zone-indicator';

		return connectDropTarget(
				connectDragPreview(
					<div>
						<div className={topDropZoneClasses}></div>
						<div className={optionClasses} onBlur={this.handleBlur}>
							<div style={{ padding: 0, margin: '3px 5px 0 0' }} className='left tools'>
								{connectDragSource(
									<a className='move' href='javascript:;'>
										<SVGIcon name='drag-handle' />
									</a>
								)}
							</div>
							<InputLabel width='100%' ref='label' label={localization.localize(this.props.label)} placeholder='Option' />
							{ (isItem || numOptions > 1) &&
								<div className='tools'>
									<a className='delete' href='javascript:;' onClick={this.remove}>
										<SVGIcon name='trash-o' />
									</a>
								</div>
							}
						</div>
						<div className={bottomDropZoneClasses}></div>
					</div>
				));
	}
}

export class OptionList extends React.Component {

	constructor(props) {
		super(props);
		this.doRender = {value: true};
	}

	componentDidUpdate() {
		// Add two options to new menu
		if ( !this.props.initialized ) {
			const {
				fieldsetIndex,
				rowIndex,
				index
			} = this.props;

		FormActions.initializeSelectMenu(fieldsetIndex, rowIndex, index);
		}
	}

	componentDidMount(){
		if ( !this.props.initialized ) {
			// Add ${ec.getWebsiteCountry()} states to the list
			if(this.props.country){
				FormActions.initializeAddressSTATES(this.props.fieldsetIndex, this.props.rowIndex, this.props.index);
			}
		}
	}

	removeAllOptions = () => {
		const {
			fieldsetIndex,
			rowIndex,
			index
		} = this.props;

		FormActions.removeAllOptionsFromSelectMenu(fieldsetIndex, rowIndex, index);
	}

	render() {
		const {
			fieldsetIndex,
			rowIndex,
			index,
			placeholder,
			options,
			addOptionCallback,
			bulkEditCallback,
			removeOptionCallback,
			country,
			isItem
		} = this.props;

		let localization = new Localization(window.edlio.localizations);
		return (
			<div>
				<div className='mockup'>
					<div style={{display: 'flex', alignItems: 'center'}}>
						<div className="option-group" style={{width: 'fit-content'}}>
							<div className="placeholder" style={{ width: '100%', marginLeft: 0 }}>
								{placeholder}
								<SVGIcon color={cmsColors.grey3} name='caret-down' />
							</div>
						</div>
						{/* This removeAllOptions icon should only exist on an Item payment element */}
						{ isItem &&
							<div className='tools'>
								<a className='delete' href='javascript:;' onClick={this.removeAllOptions}>
									<SVGIcon name='trash-o' />
								</a>
							</div>
						}
					</div>
					<div className="option-group" style={{padding: '0 1em 0 0.4em'}}>
						{ options.length > 0 &&
							<div className='options'>
							{
								options.map((option, optionNumber) => {
									return (
										<Option
											fieldsetIndex={fieldsetIndex}
											rowIndex={rowIndex}
											index={index}
											label={localization.localize(option.value)}
											optionNumber={optionNumber}
											isItem={isItem}
											numOptions={options.length}
											key={option.uniqueId}
										/>
									);
								})
							}
							</div>
						}
					</div>
					<aside className='add-to-group'>
						<a className='add' href='javascript:;' onClick={addOptionCallback}>{localization.localize('Add Option')}</a>
						{ bulkEditCallback &&
							<span>
								{' | '}
								<a className='add bulk-edit' href='javascript:;' onClick={bulkEditCallback}>{localization.localize('Bulk Edit')}</a>
							</span>
						}
					</aside>
				</div>
			</div>
		);
	}
}

export default class SelectMenuElement extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			bulkEditVisible: false
		};

		this.addOption = this.addOption.bind(this);
		this.openBulkEdit = this.openBulkEdit.bind(this);
		this.closeBulkEdit = this.closeBulkEdit.bind(this);
		this.confirmBulkEdit = this.confirmBulkEdit.bind(this);
	}

	/**
	 * @method addOption
	 * render new option when user clicks "Add Option"
	 */
	addOption() {
		const {
			fieldsetIndex,
			rowIndex,
			index
		} = this.props;

		FormActions.addOptionToSelectMenu(fieldsetIndex, rowIndex, index);
	}

	openBulkEdit() {
		this.setState({ bulkEditVisible: true });
	}

	closeBulkEdit() {
		this.setState({ bulkEditVisible: false });
	}

	confirmBulkEdit(labels) {
		const {
			fieldsetIndex,
			rowIndex,
			index
		} = this.props;

		FormActions.bulkReplaceOptions(fieldsetIndex, rowIndex, index, 'selectOptions', labels);
		this.closeBulkEdit();
	}

	render() {
		const {
			fieldsetIndex,
			rowIndex,
			index,
			usePlaceholderLabel
		} = this.props;

		const {
			initialized,
			label,
			hint,
			attributes,
			options,
			required,
			country
		} = this.props.data;

		return (
			<div className='select-menu input'>
				<header>
					<InputLabel ref='label' label={label} required={required} usePlaceholderLabel={usePlaceholderLabel} />
					<InputHint ref='hint' hint={hint} />
				</header>
				<OptionList
					country={country}
					initialized={initialized}
					fieldsetIndex={fieldsetIndex}
					rowIndex={rowIndex}
					index={index}
					placeholder={attributes.placeholder}
					options={options}
					addOptionCallback={this.addOption}
					bulkEditCallback={this.openBulkEdit}
				/>
				<BulkEditOptionsModal
					visible={this.state.bulkEditVisible}
					options={options.map(option => option.value)}
					onClose={this.closeBulkEdit}
					onConfirm={this.confirmBulkEdit}
				/>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/editor/components/form-elements/input-groups/select-menu.js